import { useAuth } from 'src/hooks';
import { useQuery, UseQueryResult } from 'react-query';

import { getTextTypeFormat } from 'src/utils/urls';

async function fetchGetTextTypeFormat({
  token,
  tokenType,
}: TVariables): Promise<APIResult> {
  const response = await fetch(getTextTypeFormat, {
    method: 'GET',
    headers: {
      Authorization: `${tokenType} ${token}`,
    },
  });
  return response.json();
}

type APIResult = Array<TextFormatType>;
export type TextFormatType = {
  Description: string;
  Id: number;
  Pattern: string;
};

type TError = { message: string };
type TVariables = {
  token: string;
  tokenType: string;
};

function useTextTypeFormat(): UseQueryResult<APIResult, TError> {
  const { token, tokenType } = useAuth();
  return useQuery(
    ['get_texttype_format'],
    async () => {
      const result = await fetchGetTextTypeFormat({
        token,
        tokenType,
      });
      return result;
    },
    {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  );
}

export { useTextTypeFormat };
